import Map from "../common/Map";

const TrainingMap = () => {
  return (
    <div className="pb-5 pt-3" >
      <div className="container">
        <h4 className="fs_43 fw-bold ff_inter color_darkgray text-center">
          Our Institutes 
          <span className="custom-color" > Across India</span>
        </h4>
        {/* <p className="fs_24 fw-normal ff_inter color_darkgray">Search on Map</p> */}
        <Map />
      </div>
    </div>
  );
};

export default TrainingMap;
